// extracted by mini-css-extract-plugin
export default {"melodyVideo":"QK-z","isFullWidth":"RK-z","landingPageVideo":"SK-z","play":"TK-z","iframeVideo":"UK-z","playHidden":"VK-z","fullwidth":"WK-z"};